import Icon from '@planday-corp/ui/icons/Icon';
import styled from 'styled-components';

export const StyledUl = styled.ul`
  list-style: none;
  padding: 0;
  margin-top: 1.5rem;
`;

export const StyledLi = styled.li`
  display: flex;
  padding-bottom: 1rem;
`;

export const StyledIcon = styled(Icon)`
  margin-right: 1rem;
  flex-shrink: 0;
`;
